import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { BanksParticipantsModalComponent } from '../../shared/components/modal/banks-participants-modal/banks-participants-modal.component';

@Injectable({
  providedIn: 'root'
})
export class BanksParticipantsModalService {

  constructor(
    private readonly modalService: NgbModal,
    @Inject(PLATFORM_ID) private readonly platformId: Object
  ) {}

  open(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    this.modalService.open(BanksParticipantsModalComponent, {
      centered: true,
      size: 'lg',
      scrollable: true,
      backdrop: true,
      windowClass: 'banks-participants-modal-window'
    });
  }
}
